import { Component, OnInit, ɵConsole, Input } from '@angular/core';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-direct-debit',
  templateUrl: './direct-debit.component.html',
  styleUrls: ['./direct-debit.component.sass']
})
export class DirectDebitComponent implements OnInit {
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token;
  public tabActive = 'Factura y Pago';

  public screen = 1;
  public hasAfiliation = false;
  public infoAfiliation;
  public affiliate = 'Tarjeta de Crédito';
  public typeCard;
  public bank = '*';

  public tiposPago = [];
  loadObserver: Subscription;
  constructor(private services: Service, private loadingScreenService: LoadingScreenService, public global: GlobalService, public AngularFireAnalytics: AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Débito directo");
    this.AngularFireAnalytics.logEvent("Débito directo-Screenview");
  }

  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.token= sessionStorage.getItem("token");
      this.activate();
      this.loadObserver = this.global.loadObserver.subscribe((value: number) => {
        this.dataLoading(value)
      });
    }
  }

  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
    this.activate();
  }
  refreshDataTo(event: Event) {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  activate() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.loadingScreenService.startLoading();
    this.services.getDirectDebitInfo(this.token, this.selectBan).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        // if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
        //   this.global.notif(data.ErrorDesc);
        // }
        if (data.mType === undefined) {
          this.infoAfiliation = data.data; //prod
        }
        else {
          this.infoAfiliation = data; //dev
        }
        if (this.infoAfiliation === '' || this.infoAfiliation.mType === null) {
          this.screen = 4;
        }
        else {
          if (this.infoAfiliation.mType === 'CC') {
            this.screen = 4;
            this.affiliate = 'Tarjeta de Crédito';
          }
          else {
            this.screen = 3;
            this.affiliate = 'Cuenta de Cheques';
          }
          this.cardType(this.infoAfiliation.mCreditCardType);
          this.codeBank(this.infoAfiliation.mBankCode);
          if (this.infoAfiliation.mCreditCardNo !== '' || this.infoAfiliation.mCreditCardNo !== null) {
            this.infoAfiliation.mCreditCardNo = this.convertNum(this.infoAfiliation.mCreditCardNo);
          }
        }
      }
      else {
        this.screen = 4;
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  cardType(type) {
    if (this.global.validateSession() === true) {
      if (type === 'VS') {
        this.typeCard = 'visa';
      }
      if (type === 'AM') {
        this.typeCard = 'American Express ';
      }
      if (type === 'MC') {
        this.typeCard = 'MasterCard ';
      }
    }
  }
  codeBank(code) {
    if (this.global.validateSession() === true) {
      if (code === '021502011') {
        this.bank = 'Banco Popular of Puerto Rico';
      }
      else if (code === '021502341') {
        this.bank = 'Banco Santander of Puerto Rico';
      }
      else if (code === '221571473') {
        this.bank = 'Firstbank, P.R.';
      }
      else if (code === '021502804') {
        this.bank = 'Scotiabank of Puerto Rico';
      }
      else if (code === '221571415') {
        this.bank = 'Oriental Bank';
      }
      else if (code === '221582284') {
        this.bank = 'COOP. MANATI';
      }
      else if (code === '021582785') {
        this.bank = 'COOP. ISABELA';
      }
      else if (code === '021583658') {
        this.bank = 'COOP.ENERGIA ELECTRICA';
      }
      else if (code === '021582727') {
        this.bank = 'COOP. SAGRADA FAMILIA';
      }
      else if (code === '021582853') {
        this.bank = 'COOP. LAS PIEDRAS';
      }
      else if (code === '221582226') {
        this.bank = 'COOP. CAMUY';
      }
      else if (code === '221581706') {
        this.bank = 'COOP. MOCA';
      }
      else if (code === '021583247') {
        this.bank = 'COOP. SABANENA';
      }
      else if (code === '221582459') {
        this.bank = 'COOP.LA PUERTORRIQUENA';
      }
      else if (code === '267089712') {
        this.bank = 'FIRST BANK US V.G.';
      }
      else if (code === '221581641') {
        this.bank = 'COOP. ARECIBO';
      }
      else if (code === '021582743') {
        this.bank = 'COOP. SAN JOSE';
      }
      else if (code === '021584217') {
        this.bank = 'COOP. LOS HERMANOS';
      }
      else if (code === '021582976') {
        this.bank = 'COOP. AGUADA';
      }
      else if (code === '021583373') {
        this.bank = 'COOP.BARRIO QUEBRADA';
      }
      else if (code === '021583593') {
        this.bank = 'COOP. VILLALBA';
      }
      else if (code === '021583137') {
        this.bank = 'COOP. ANASCO';
      }
      else if (code === '021583360') {
        this.bank = 'COOP. MAYAGUEZ';
      }
      else if (code === '221672851') {
        this.bank = 'FIRST BANK US V.I.';
      }
      else if (code === '221581751') {
        this.bank = 'COOP. VALENCIANO';
      }
      else if (code === '221581722') {
        this.bank = 'COOP. MAUNABO';
      }
      else if (code === '221582077') {
        this.bank = 'COOP. JAYUYA';
      }
      else if (code === '021583111') {
        this.bank = 'COOP. SAN BLAS';
      }
      else if (code === '021583140') {
        this.bank = 'COOP. NAGUABENA';
      }
      else if (code === '021582662') {
        this.bank = 'COOP. CAGUAS';
      }
      else if (code === '021583328') {
        this.bank = 'COOP. CAPARRA';
      }
      else if (code === '021583056') {
        this.bank = 'COOP. CIALES';
      }
      else if (code === '021583027') {
        this.bank = 'COOP. VEGA ALTA';
      }
      else if (code === '021582756') {
        this.bank = 'COOP. AGUAS BUENAS';
      }
      else if (code === '221581748') {
        this.bank = 'COOP. ORIENTAL';
      }
      else if (code === '221582310') {
        this.bank = 'COOP. CABO ROJO';
      }
      else if (code === '021582701') {
        this.bank = 'COOP. GURABO';
      }
      else if (code === '021583483') {
        this.bank = 'COOP. PARROCOOP';
      }
      else if (code === '221582174') {
        this.bank = 'COOP. YAUCO';
      }
      else if (code === '021502040') {
        this.bank = 'CITIBANK';
      }
      else if (code === '221582323') {
        this.bank = 'HATICOOP';
      }
    }
  }
  convertNum(num) {
    try {
      return num.substr(num.length - 4);
    }
    catch (error) {
      return "***";
    }

  }
}
